import type React from 'react';
import { useEffect, useState } from 'react';

interface ExpireProps {
  delay: number;
  children: React.ReactNode;
}

const Expire = ({ delay, children }: ExpireProps) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    setVisible(true);
    const timer = setTimeout(() => {
      setVisible(false);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  if (!visible) {
    return null;
  }

  return <>{children}</>;
};

export default Expire;
